import dayjs from 'dayjs';

function parseTime(time: string) {
  const args = time.split(':');
  if (args.length === 1) {
    args.push('00');
  }
  const hour = parseInt(args[0]);
  const minute = parseInt(args[1]);
  const d = dayjs().hour(hour).minute(minute);
  return d;
}

export { parseTime };
